module.exports = __webpack_public_path__ + "img/logo_white_560.33925e62.png";